// @flow

export type Role = 'TANKER' | 'WARRIOR' | 'RANGED' | 'SUPPORT';
export type Element = 'BASIC' | 'WATER' | 'LIGHT' | 'FIRE' | 'EARTH' | 'DARK';
export type Weapon =
  'Bow'
  | 'OneHandedSword'
  | 'TwoHandedSword'
  | 'Shield'
  | 'Staff'
  | 'Rifle'
  | 'Basket'
  | 'Claw'
  | 'Gauntlet';
export type Resistance = { type: Element, value: number };
export type Attribute =
  'HP'
  | 'DEF'
  | 'HEAL'
  | 'SKILL_ATK'
  | 'ATK'
  | 'WEAPON_SKILL_REGEN_SPEED'
  | 'CRITICAL_HIT_CHANCE';
export type SkillTarget = 'SELF' | 'PARTY' | 'RANGED' | Element;
export type Skill = {
  target: SkillTarget,
  attribute: Attribute,
  value: number
};
export type Hero = {
  name: string,
  role: Role,
  element: Element,
  weapons: Array<Weapon>,
  atk: number,
  criticalHitChance: number,
  hp: number,
  def: number,
  heal: number,
  damageReduction: number,
  cardSlot: number,
  resistance: Array<Resistance>,
  skills: Array<Skill>
};

const heroes: Array<Hero> = [
  {
    name: 'Marina',
    role: 'TANKER',
    element: 'WATER',
    weapons: ['OneHandedSword'],
    atk: 659,
    criticalHitChance: 0.0,
    hp: 23471,
    def: 398,
    heal: 0,
    damageReduction: 19,
    cardSlot: 2,
    resistance: [
      {type: 'FIRE', value: 0.3},
      {type: 'EARTH', value: -0.3},
    ],
    skills: [{
      target: 'PARTY',
      attribute: 'HP',
      value: 0.4,
    }, {
      target: 'SELF',
      attribute: 'WEAPON_SKILL_REGEN_SPEED',
      value: 0.08,
    }],
  },
  {
    name: 'Lapice',
    role: 'WARRIOR',
    element: 'LIGHT',
    weapons: ['OneHandedSword', 'Shield'],
    atk: 629,
    criticalHitChance: 0.08,
    hp: 19941,
    def: 125,
    heal: 0,
    damageReduction: 26,
    cardSlot: 2,
    resistance: [
      {type: 'BASIC', value: -0.3},
      {type: 'DARK', value: 0.3},
    ],
    skills: [{
      target: 'LIGHT',
      attribute: 'ATK',
      value: 0.4,
    }, {
      target: 'SELF',
      attribute: 'WEAPON_SKILL_REGEN_SPEED',
      value: 0.06,
    }],
  },
  {
    name: 'Tinia',
    role: 'RANGED',
    element: 'EARTH',
    weapons: ['Bow'],
    atk: 689,
    criticalHitChance: 0.03,
    hp: 18426,
    def: 124,
    heal: 0,
    damageReduction: 30,
    cardSlot: 2,
    resistance: [
      {type: 'FIRE', value: -0.3},
      {type: 'WATER', value: 0.3},
    ],
    skills: [{
      target: 'RANGED',
      attribute: 'ATK',
      value: 0.50,
    }],
  },
  {
    name: 'Eva',
    role: 'SUPPORT',
    element: 'BASIC',
    weapons: ['Staff'],
    atk: 642,
    criticalHitChance: 0.06,
    hp: 18818,
    def: 121,
    heal: 0,
    damageReduction: 24,
    cardSlot: 2,
    resistance: [
      {type: 'DARK', value: -0.3},
      {type: 'LIGHT', value: 0.3},
    ],
    skills: [{
      target: 'BASIC',
      attribute: 'ATK',
      value: 0.40,
    }],
  },
  {
    name: 'Male Knight',
    role: 'WARRIOR',
    element: 'BASIC',
    weapons: ['OneHandedSword', 'Shield', 'TwoHandedSword', 'Bow', 'Rifle'],
    atk: 565,
    criticalHitChance: 0.03,
    hp: 20028,
    def: 105,
    heal: 0,
    damageReduction: 18,
    cardSlot: 2,
    resistance: [
      {type: 'DARK', value: -0.3},
      {type: 'LIGHT', value: 0.3},
    ],
    skills: [{
      target: 'BASIC',
      attribute: 'ATK',
      value: 0.36,
    }, {
      target: 'SELF',
      attribute: 'WEAPON_SKILL_REGEN_SPEED',
      value: 0.05,
    }],
  },
  {
    name: 'Bari',
    role: 'RANGED',
    element: 'EARTH',
    weapons: ['Basket'],
    atk: 977,
    criticalHitChance: 0.03,
    hp: 18082,
    def: 155,
    heal: 0,
    damageReduction: 22,
    cardSlot: 2,
    resistance: [
      {type: 'FIRE', value: -0.3},
      {type: 'WATER', value: 0.3},
    ],
    skills: [],
  },
  {
    name: 'Elvira',
    role: 'RANGED',
    element: 'FIRE',
    weapons: ['Rifle'],
    atk: 684,
    criticalHitChance: 0.02,
    hp: 17642,
    def: 98,
    heal: 0,
    damageReduction: 23,
    cardSlot: 2,
    resistance: [
      {type: 'WATER', value: -0.3},
      {type: 'EARTH', value: 0.3},
    ],
    skills: [{
      target: 'RANGED',
      attribute: 'ATK',
      value: 0.48,
    }],
  },
  {
    name: 'Karina',
    role: 'SUPPORT',
    element: 'DARK',
    weapons: ['Staff'],
    atk: 590,
    criticalHitChance: 0.03,
    hp: 18758,
    def: 95,
    heal: 0,
    damageReduction: 18,
    cardSlot: 2,
    resistance: [
      {type: 'LIGHT', value: -0.3},
      {type: 'BASIC', value: 0.3},
    ],
    skills: [{
      target: 'DARK',
      attribute: 'ATK',
      value: 0.30,
    }],
  },
  {
    name: 'Plitvice',
    role: 'WARRIOR',
    element: 'FIRE',
    weapons: ['TwoHandedSword'],
    atk: 625,
    criticalHitChance: 0.03,
    hp: 20091,
    def: 154,
    heal: 0,
    damageReduction: 22,
    cardSlot: 2,
    resistance: [
      {type: 'WATER', value: -0.3},
      {type: 'EARTH', value: 0.3},
    ],
    skills: [{
      target: 'FIRE',
      attribute: 'ATK',
      value: 0.40,
    }],
  },
  {
    name: 'Sohee',
    role: 'RANGED',
    element: 'LIGHT',
    weapons: ['Rifle'],
    atk: 595,
    criticalHitChance: 0.00,
    hp: 20775,
    def: 125,
    heal: 0,
    damageReduction: 18,
    cardSlot: 2,
    resistance: [
      {type: 'BASIC', value: -0.3},
      {type: 'DARK', value: 0.3},
    ],
    skills: [{
      target: 'FIRE',
      attribute: 'ATK',
      value: 0.40,
    }],
  },
  {
    name: 'Rachel',
    role: 'RANGED',
    element: 'WATER',
    weapons: ['Rifle'],
    atk: 688,
    criticalHitChance: 0.11,
    hp: 16434,
    def: 88,
    heal: 0,
    damageReduction: 26,
    cardSlot: 2,
    resistance: [
      {type: 'EARTH', value: -0.3},
      {type: 'FIRE', value: 0.3},
    ],
    skills: [{
      target: 'RANGED',
      attribute: 'ATK',
      value: 0.48,
    }],
  },
  {
    name: 'Ranpang',
    role: 'TANKER',
    element: 'BASIC',
    weapons: ['Claw'],
    atk: 403,
    criticalHitChance: 0.04,
    hp: 22233,
    def: 170,
    heal: 0,
    damageReduction: 32,
    cardSlot: 2,
    resistance: [
      {type: 'DARK', value: -0.3},
      {type: 'LIGHT', value: 0.3},
    ],
    skills: [{
      target: 'PARTY',
      attribute: 'DEF',
      value: 0.42,
    }],
  },
  {
    name: 'Yuze',
    role: 'WARRIOR',
    element: 'DARK',
    weapons: ['TwoHandedSword'],
    atk: 521,
    criticalHitChance: 0.06,
    hp: 17967,
    def: 134,
    heal: 0,
    damageReduction: 12,
    cardSlot: 2,
    resistance: [
      {type: 'LIGHT', value: -0.3},
      {type: 'BASIC', value: 0.3},
    ],
    skills: [{
      target: 'PARTY',
      attribute: 'HP',
      value: 0.36,
    }],
  },
  {
    name: 'Aoba',
    role: 'SUPPORT',
    element: 'EARTH',
    weapons: ['Bow'],
    atk: 615,
    criticalHitChance: 0.05,
    hp: 16833,
    def: 120,
    heal: 1233,
    damageReduction: 15,
    cardSlot: 2,
    resistance: [
      {type: 'FIRE', value: -0.3},
      {type: 'WATER', value: 0.3},
    ],
    skills: [{
      target: 'EARTH',
      attribute: 'ATK',
      value: 0.35,
    }],
  },
  {
    name: 'Loraine',
    role: 'SUPPORT',
    element: 'BASIC',
    weapons: ['Basket'],
    atk: 491,
    criticalHitChance: 0.02,
    hp: 18025,
    def: 101,
    heal: 1419,
    damageReduction: 28,
    cardSlot: 2,
    resistance: [
      {type: 'DARK', value: -0.3},
      {type: 'LIGHT', value: 0.3},
    ],
    skills: [],
  },
  {
    name: 'Lupina',
    role: 'WARRIOR',
    element: 'DARK',
    weapons: ['Staff'],
    atk: 682,
    criticalHitChance: 0.07,
    hp: 19270,
    def: 130,
    heal: 0,
    damageReduction: 18,
    cardSlot: 2,
    resistance: [
      {type: 'LIGHT', value: -0.3},
      {type: 'BASIC', value: 0.3},
    ],
    skills: [{
      target: 'PARTY',
      attribute: 'CRITICAL_HIT_CHANCE',
      value: 0.27,
    }],
  },
  {
    name: 'Eugene',
    role: 'WARRIOR',
    element: 'LIGHT',
    weapons: ['TwoHandedSword'],
    atk: 631,
    criticalHitChance: 0.02,
    hp: 19368,
    def: 177,
    heal: 0,
    damageReduction: 28,
    cardSlot: 2,
    resistance: [
      {type: 'BASIC', value: -0.3},
      {type: 'DARK', value: 0.3},
    ],
    skills: [{
      target: 'SELF',
      attribute: 'WEAPON_SKILL_REGEN_SPEED',
      value: 0.06,
    }],
  },
  {
    name: 'Lahn',
    role: 'WARRIOR',
    element: 'BASIC',
    weapons: ['Gauntlet'],
    atk: 646,
    criticalHitChance: 0.05,
    hp: 18792,
    def: 131,
    heal: 0,
    damageReduction: 16,
    cardSlot: 2,
    resistance: [
      {type: 'DARK', value: -0.3},
      {type: 'LIGHT', value: 0.3},
    ],
    skills: [{
      target: 'PARTY',
      attribute: 'HP',
      value: 0.40,
    }],
  },
  {
    name: 'White Beast',
    role: 'WARRIOR',
    element: 'WATER',
    weapons: ['Claw'],
    atk: 592,
    criticalHitChance: 0.05,
    hp: 19628,
    def: 141,
    heal: 0,
    damageReduction: 28,
    cardSlot: 2,
    resistance: [
      {type: 'EARTH', value: -0.3},
      {type: 'FIRE', value: 0.3},
    ],
    skills: [{
      target: 'WATER',
      attribute: 'ATK',
      value: 0.36,
    }],
  },
  {
    name: 'Lavi',
    role: 'TANKER',
    element: 'FIRE',
    weapons: ['Gauntlet'],
    atk: 438,
    criticalHitChance: 0.03,
    hp: 22133,
    def: 197,
    heal: 0,
    damageReduction: 30,
    cardSlot: 2,
    resistance: [
      {type: 'WATER', value: -0.3},
      {type: 'EARTH', value: 0.3},
    ],
    skills: [{
      target: 'PARTY',
      attribute: 'DEF',
      value: 0.48,
    }],
  },
  {
    name: 'Favi',
    role: 'SUPPORT',
    element: 'WATER',
    weapons: ['Basket'],
    atk: 446,
    criticalHitChance: 0.00,
    hp: 17315,
    def: 179,
    heal: 1298,
    damageReduction: 34,
    cardSlot: 2,
    resistance: [
      {type: 'EARTH', value: -0.3},
      {type: 'FIRE', value: 0.3},
    ],
    skills: [],
  },
  {
    name: 'Gremory',
    role: 'RANGED',
    element: 'DARK',
    weapons: ['Basket'],
    atk: 520,
    criticalHitChance: 0.07,
    hp: 17177,
    def: 108,
    heal: 0,
    damageReduction: 24,
    cardSlot: 2,
    resistance: [
      {type: 'LIGHT', value: -0.3},
      {type: 'BASIC', value: 0.3},
    ],
    skills: [{
      target: 'PARTY',
      attribute: 'SKILL_ATK',
      value: 0.72,
    }],
  },
  {
    name: 'Arabelle',
    role: 'RANGED',
    element: 'DARK',
    weapons: ['Rifle'],
    atk: 724,
    criticalHitChance: 0.05,
    hp: 18409,
    def: 106,
    heal: 0,
    damageReduction: 16,
    cardSlot: 2,
    resistance: [
      {type: 'LIGHT', value: -0.3},
      {type: 'BASIC', value: 0.3},
    ],
    skills: [{
      target: 'DARK',
      attribute: 'ATK',
      value: 0.40,
    }, {
      target: 'SELF',
      attribute: 'SKILL_ATK',
      value: 0.10,
    }],
  }, {
    name: 'Aisha',
    role: 'RANGED',
    element: 'FIRE',
    weapons: ['Staff'],
    atk: 712,
    criticalHitChance: 0.00,
    hp: 16561,
    def: 76,
    heal: 0,
    damageReduction: 34,
    cardSlot: 2,
    resistance: [
      {type: 'WATER', value: -0.3},
      {type: 'EARTH', value: 0.3},
    ],
    skills: [{
      target: 'PARTY',
      attribute: 'WEAPON_SKILL_REGEN_SPEED',
      value: 0.20,
    }, {
      target: 'SELF',
      attribute: 'SKILL_ATK',
      value: 0.10,
    }],
  }, {
    name: 'Vishuvac',
    role: 'WARRIOR',
    element: 'FIRE',
    weapons: ['Claw'],
    atk: 644,
    criticalHitChance: 0.04,
    hp: 19227,
    def: 149,
    heal: 0,
    damageReduction: 26,
    cardSlot: 2,
    resistance: [
      {type: 'WATER', value: -0.3},
      {type: 'EARTH', value: 0.3},
    ],
    skills: [{
      target: 'PARTY',
      attribute: 'HP',
      value: 0.40,
    }, {
      target: 'SELF',
      attribute: 'SKILL_ATK',
      value: 0.05,
    }],
  }, {
    name: 'Nari',
    role: 'RANGED',
    element: 'BASIC',
    weapons: ['Basket'],
    atk: 760,
    criticalHitChance: 0.00,
    hp: 17966,
    def: 107,
    heal: 0,
    damageReduction: 18,
    cardSlot: 2,
    resistance: [
      {type: 'DARK', value: -0.3},
      {type: 'LIGHT', value: 0.3},
    ],
    skills: [{
      target: 'RANGED',
      attribute: 'ATK',
      value: 0.50,
    }, {
      target: 'SELF',
      attribute: 'SKILL_ATK',
      value: 0.18,
    }],
  },
];

module.exports = heroes;
